// src/pages/Home.jsx
import React from "react";
import Layout from '../components/layout/Layout';

const Home = () => {
  return (
    <Layout>
      <div
        className="d-flex align-items-center justify-content-center text-white"
        style={{
          height: "90vh",
          backgroundImage:
            "linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url('https://images.unsplash.com/photo-1573497620053-ea5300f94f21?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div
          className="text-center px-4 py-5 rounded"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.5)", maxWidth: "700px", width: "100%" }}
        >
          <h1 className="display-4 fw-bold">Your Mental Health Matters</h1>
          <p className="lead">
            Connect with licensed physicians and get support through our AI-powered chatbot.
          </p>
          <div className="d-flex justify-content-center gap-3 flex-wrap mt-4">
            <a href="/register" className="btn btn-primary btn-lg">
              Get Started
            </a>
            <a href="/physicians" className="btn btn-outline-light btn-lg">
              Meet Our Physicians
            </a>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Home;
